export default __webpack_public_path__ + "static/zach-bitmoji-44b34051f8e3179392e45515e825f60b.png";